
export default {
  name: "reasons-header",
};
